// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Gl70Q","ContactInfo":"Contact_ContactInfo__kKzDD","Error":"Contact_Error__R5Bro"};